// extracted by mini-css-extract-plugin
module.exports = {"yunxin-bottom":"yunxin-bottom___2ZHgm"};